<template>
  <layout-basic>
    <b-container class="mt-3">
      <b-card class="data-card">
        <template v-slot:header>
          <h4 class="mb-0 pt-1 flex-shrink-0 mr-auto">
            My Account
          </h4>
        </template>
        <b-form @submit.stop.prevent="onSubmit">
          <b-row>
            <b-col
              sm="6"
              cols="12"
            >
              <b-form-group
                id="input-group-fname"
                label="First Name"
                label-for="input-fname"
              >
                <b-input
                  id="input-fname"
                  v-model="$v.form.firstName.$model"
                  :state="validateState('firstName')"
                  aria-describedby="input-fname-live-feedback"
                  type="text"
                />
                <b-form-invalid-feedback id="input-fname-live-feedback">
                  First name is required
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                id="input-group-lname"
                label="Last Name"
                label-for="input-lname"
              >
                <b-input
                  id="input-lname"
                  v-model="$v.form.lastName.$model"
                  :state="validateState('lastName')"
                  aria-describedby="input-lname-live-feedback"
                  type="text"
                />
                <b-form-invalid-feedback id="input-lname-live-feedback">
                  Last name is required
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                id="input-group-email"
                label="Email"
                label-for="input-email"
              >
                <b-input
                  id="input-email"
                  :value="$v.form.email.$model"
                  :state="validateState('email')"
                  readonly
                  aria-describedby="input-email-live-feedback"
                  type="email"
                />
              </b-form-group>
              <b-form-group
                id="input-group-position"
                label="Position"
                label-for="input-position"
              >
                <b-input
                  id="input-position"
                  v-model="$v.form.position.$model"
                  type="text"
                  :state="validateState('position')"
                />
              </b-form-group>
            </b-col>
            <b-col
              sm="6"
              cols="12"
            >
              <b-form-group
                id="input-group-currentpassword"
                label="Current Password"
                label-for="input-currentpassword"
              >
                <b-input
                  id="input-currentpassword"
                  v-model="$v.form.currentPassword.$model"
                  type="password"
                  :state="validateState('currentPassword')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-newpassword"
                label="New Password"
                label-for="input-newpassword"
              >
                <b-input
                  id="input-newpassword"
                  v-model="$v.form.newPassword.$model"
                  type="password"
                  :state="validateState('newPassword')"
                />
              </b-form-group>
              <b-form-group
                id="input-group-confirmpassword"
                label="Confirm Password"
                label-for="input-confirmpassword"
              >
                <b-input
                  id="input-confirmpassword"
                  v-model="$v.form.confirmPassword.$model"
                  aria-describedby="input-password-live-feedback"
                  :state="validateState('confirmPassword')"
                  type="password"
                />
                <b-form-invalid-feedback id="input-password-live-feedback">
                  Passwords must be identical.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-end">
            <b-button
              :disabled="!$v.form.$anyDirty"
              type="submit"
              variant="primary"
            >
              Save Changes
            </b-button>
          </div>
          <b-form />
        </b-form>
      </b-card>
    </b-container>
  </layout-basic>
</template>

<script>
  import LayoutBasic from "@/layouts/LayoutBasic";
  import {required, sameAs} from "vuelidate/lib/validators";
  import validateStateMixin from "../mixins/validateStateMixin";

  export default {
    name: "MyAccount",
    components: {
      LayoutBasic
    },
    mixins: [validateStateMixin],
    data() {
      return {
        form: {
          firstName: "",
          lastName: "",
          email: "",
          position: "",
          currentPassword: "",
          newPassword: "",
          confirmPassword: ""
        },
        show: true
      };
    },
    validations: {
      form: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        email: {},
        position: {},
        currentPassword: {},
        newPassword: {},
        confirmPassword: {
          sameAsPassword: sameAs('newPassword')
        }
      }
    },
    watch: {
      async $route(to, from) {
        if (to.name === 'myaccount') {
          await this.getData();
        }
      },
    },
    async created() {
      await this.getData();
    },
    methods: {
      async onSubmit(evt) {
        evt.preventDefault();
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          return;
        }
        try{
          await this.$http.post('myaccount',this.form)
          this.successAlert(`Account was successfully updated.`)
        }catch(error){
          this.handleErrorResponse(error)
        }
      },
      async getData() {
        try {
          let response = await this.$http(`myaccount`);
          this.form.firstName = response.data.firstName;
          this.form.lastName = response.data.lastName;
          this.form.email = response.data.email;
          this.form.position = response.data.position;
        } catch (error) {
          this.handleErrorResponse(error)
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import "@/assets/variables.scss";
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";

  .data-card .card-header {
    padding-left: 12px;
    padding-right: 12px;

    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @include media-breakpoint-down(sm) {
      padding-left: 0px;
    }
  }

  .data-card .card-header > * {
    &:not(:first-child) {
      margin-left: 12px;
    }

    @include media-breakpoint-down(sm) {
      margin-bottom: 6px;
    }
  }

  h4 {
    @include media-breakpoint-down(sm) {
      flex-basis: 100%;
      margin-left: 12px;
    }
  }
</style>